<template>
  <b-container class="mb-4 pb-4">
    <form @submit="onSubmit" @reset="onReset" class="mt-4">
      <b-row>
        <b-col lg="3" sm="6" xs="6">
          <b-form-group>
            <label>Número identifiación</label>
            <b-form-input
              type="number"
              v-model="search.numberIdentication"
              placeholder="Número de identificación"
            />
          </b-form-group>
        </b-col>

        <b-col md="4" sm="5" class="d-none d-sm-block">
          <div class="mt-4 pt-2">
            <b-button type="reset" pill size="sm" variant="secondary">
              <span>
                <font-awesome-icon icon="paint-brush" />
              </span> Limpiar
            </b-button>
            <b-button type="submit" pill size="sm" variant="primary">
              <span>
                <font-awesome-icon icon="search" />
              </span> Buscar
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="3" sm="6">
          <b-form-group>
            <label>Nombre</label>
            <b-form-input type="text" v-model="search.namePatient" placeholder="Ingrese el nombre" />
          </b-form-group>
        </b-col>

        <b-col lg="3" sm="6">
          <b-form-group>
            <label>Modalidad</label>
            <v-select
              multiple
              :options="['CR', 'CT', 'MR', 'US', 'DX']"
              placeholder="Seleccione la modalidad"
              v-model="search.typeStudy"
            ></v-select>
          </b-form-group>
        </b-col>

        <b-col lg="3" sm="6">
          <b-form-group>
            <div>
              <b-button variant="primary" size="sm" pill @click="getDateToday">Hoy</b-button>
              <b-button variant="primary" size="sm" pill  @click="getDateWeek">Semana</b-button>
              <b-button variant="primary" size="sm" pill @click="getDateMonth">Mes</b-button>
            </div>
            <datetime
              auto
              type="date"
              input-id="initDate"
              v-model="search.dateInit"              
              input-class="form-control"
              placeholder="Fecha inicial"
              value-zone="America/Bogota"              
            >            
            </datetime>
          </b-form-group>
        </b-col>

        <b-col lg="3" sm="6">
          <b-form-group>
            <label style="color: #1c2532">Fecha Final</label>
            <datetime
              auto
              input-id="finishDate"
              v-model="search.finishDate"              
              input-class="form-control"
              placeholder="Fecha final"
              value-zone="America/Bogota"
            >                   
            </datetime>
          </b-form-group>
        </b-col>
      </b-row>

      <b-col class="d-block d-sm-none">
        <b-button type="reset" pill size="sm" variant="secondary">
          <span>
            <font-awesome-icon icon="paint-brush" />
          </span> Limpiar
        </b-button>
        <b-button type="submit" pill size="sm" variant="primary">
          <span>
            <font-awesome-icon icon="search" />
          </span> Buscar
        </b-button>
      </b-col>
    </form>

    <b-row class="mt-4 pt-1">
      <b-col lg="4" sm="6" md="6">
        <b-form-group
          label="Registros por página"
          label-cols="6"
          label-cols-sm="6"
          label-cols-md="6"
          label-cols-lg="5"
          label-align-sm="left"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col offset-lg="4" lg="4" sm="6" md="6" >
        <b-form-group lg="6" align="right">
          <b-input-group size="sm" >
            <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Filtrar"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-table
        id="my-table"
        show-empty
        :fields="fields"
        :items="items"
        :per-page="perPage"
        :current-page="currentPage"
        :dark="true"
        :filter="filter"
        :filterIncludedFields="filterOn"
        @filtered="onFiltered"
        responsive
        hover
      >
        <template
          v-slot:cell(study.patient.familyName)="data"
        > {{ data.item.study.patient.middleName	}} {{ data.item.study.patient.namePrefix }} {{ data.item.study.patient.familyName }} {{ data.item.study.patient.givenName }}</template>

        <template v-slot:cell(study.patient.dateBorn)="data">
          <div
            v-if="(data.item.study.patient.dateBorn).length > 1"
          >{{ new Date().getFullYear() - new Date((data.item.study.patient.dateBorn).substring(0, 4) +"/"+ (data.item.study.patient.dateBorn).substring(4, 6)+"/"+(data.item.study.patient.dateBorn).substring(6, 8)).getFullYear() +" años"}}</div>
        </template>

        <template
          v-slot:cell(study.datetime)="data"
        >{{ (data.item.study.date).substring(6, 8) +"/"+ (data.item.study.date).substring(4, 6)+"/"+(data.item.study.date).substring(0, 4) +" "+ (data.item.study.time).substring(0, 2)+":"+(data.item.study.time).substring(2, 4)+":"+(data.item.study.time).substring(4, 6) }}</template>

        <template v-slot:cell(action)="data">
          <a
            :href="URI_OHIF + '/' + data.item.study.serialPacs"
            target="_blank"
            class="btn btn-primary"
          >
            <font-awesome-icon icon="image" />
          </a>
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li>Genero: {{ row.item.study.patient.genre == 'M' ? 'Masculino':'Femenino' }}</li>
              <li>Descripción: {{ row.item.study.description }}</li>
            </ul>
          </b-card>
        </template>
      </b-table>
    </b-row>
    <b-row class="mb-4 pb-4">
      <b-col sm="5" md="4">
        <label label-size="sm">{{ this.totalRows }}</label>
      </b-col>
      <b-col sm="7" md="8">
        <b-pagination
          v-model="currentPage"
          :total-rows="paginationItems"
          :per-page="perPage"
          align="right"
          aria-controls="my-table"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      URI_OHIF: this.$URI_OHIF,
      perPage: 10,
      currentPage: 1,
      pageOptions: [10, 30, 50],
      updatedStudies: true,
      fields: [
        { key: "study.patient.CC", label: "Identificación", sortable: true },
        { key: "study.patient.familyName", label: "Paciente", sortable: true },
        {
          key: "study.patient.dateBorn",
          label: "Edad",
          sortable: true
        },
        {
          key: "study.patient.genre",
          label: "Género",
          sortable: true
        },
        { key: "study.typeStudy", label: "Modalidad", sortable: true },
        {
          key: "study.description",
          label: "Descripción",
          sortable: true,
          width: "10"
        },
        { key: "study.datetime", label: "Fecha", sortable: true, width: "10" },
        { key: "action", label: "" }
      ],
      items: [],
      filter: null,
      filterOn: [],
      totalRows: null,
      paginationItems: 0,
      totalItems: 0,
      search: {
        numberIdentication: "",
        namePatient: "",
        typeStudy: null,
        dateInit: "",
        finishDate: ""
      }
    };
  },  
  watch: {
    items: function (val) {
      this.totalItems = val.length
      this.totalRows = this.getCountItems(val.length)
      this.paginationItems = val.length
    },
    currentPage: function (val) {
      this.totalRows = this.getCountItems(this.totalItems)
    },    
    perPage: function (val) {
      this.totalRows = this.getCountItems(this.totalItems)
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      if (this.search.dateInit != "" && this.search.finishDate != null) {
        if (this.search.dateInit <= this.search.finishDate) {
          this.onSearch();
        } else {
          this.$bvToast.toast("El intervalo de fechas no es correcto", {
            title: "Fecha invalida",
            autoHideDelay: 3000,
            variant: "warning"
          });
        }
      } else {
        this.onSearch();
      }
    },

    onSearch() {
      var finishDate = null;
      var initDate = null;
      if (this.search.dateInit != "") {
        initDate = this.$moment(this.search.dateInit).format("YYYYMMDD");
        finishDate = this.$moment(this.search.finishDate).format("YYYYMMDD");
      }

      if (
        this.search.numberIdentication == "" &&
        this.search.namePatient == "" &&
        this.search.typeStudy == null &&
        this.search.dateInit == "" &&
        this.search.finishDate == ""
      ) {
        this.$bvToast.toast(
          "Seleccione un parametro para realizar la consulta",
          {
            title: "Ups !",
            autoHideDelay: 3000,
            variant: "info"
          }
        );
      } else {
        this.axios
          .get(this.$apiURI_study + "/api/v1/pac-studies/search", {
            params: {
              numberIdentication: this.search.numberIdentication,
              namePatient: this.search.namePatient,
              typeStudy:
                this.search.typeStudy != null
                  ? JSON.stringify(this.search.typeStudy)
                  : null,
              initDate: initDate,
              finishDate: finishDate
            }
          })
          .then(response => (this.items = response.data));
        this.updatedStudies = false;
      }
    },

    onReset(evt) {
      this.items = [];
      this.search.numberIdentication = "";
      this.search.namePatient = "";
      this.search.typeStudy = null;
      this.search.dateInit = "";
      this.search.finishDate = "";
    },

    loadStudies(){
      if (this.$store.state.accessToken != null) {
        this.axios
        .get(this.$apiURI_study + "/api/v1/pac-studies")
        .then(response => {
          this.items = response.data;
        });
      } 
    },

    getDateToday() {
      this.search.dateInit = this.$moment(new Date()).format("YYYY-MM-DD");
      this.search.finishDate = this.$moment(new Date()).format("YYYY-MM-DD");      
    },

    getDateWeek() {             
      this.search.dateInit = this.$moment().subtract(1, "week").format("YYYY-MM-DD");
      this.search.finishDate = this.$moment(new Date()).format("YYYY-MM-DD");      
    },

     getDateMonth() {
      this.search.dateInit = this.$moment().subtract(1, "months").format("YYYY-MM-DD");
      this.search.finishDate = this.$moment(new Date()).format("YYYY-MM-DD");
    },

    onFiltered(filteredItems) {     
      this.currentPage = 1;
      this.totalItems = filteredItems.length
      this.totalRows = this.getCountItems(filteredItems.length)
      this.paginationItems = filteredItems.length 
    },

    getCountItems(items) {
      var countValue;
      var messageCount = null      
      if (items == 0) {
        messageCount = "Mostrando 0 de 0 registros";
      } else {     
        switch (this.currentPage) {
          case 1:
            countValue = this.perPage > items ? items : this.perPage
            messageCount = "Mostrando " + this.currentPage + " a " + countValue + " de " + items+ " registros"
            break;
          case 1:
            var initCount = this.perPage + this.perPage;
            countValue = initCount > items ? items : initCount;
            messageCount = "Mostrando " + (this.perPage + 1) + " a " + countValue + " de " + items + " registros";
            break;
          default:
            var initCount = (this.currentPage - 1) * this.perPage;
            countValue = initCount + this.perPage > items ? items : initCount + this.perPage;
            messageCount = "Mostrando " + (initCount + 1) + " a " + countValue + " de " + items + " registros";
            break;
        }
      }     
      return messageCount;
    }
  },
  mounted() {    
    const left = this
    this.loadStudies()
    window.setInterval(function(){      
      if(left.updatedStudies) {        
        left.loadStudies()     
      }
    }, 300000);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Index.vue